import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MultiSelectDropdownItem } from 'mis-crystal-design-system/multi-select-dropdown';
import { CommonService } from '../../services/common.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { create } from "socketcluster-client";
import * as Highcharts from 'highcharts';
import SolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsMore from 'highcharts/highcharts-more';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
// HighchartsMore(Highcharts);
// SolidGauge(Highcharts);
import { ActivatedRoute } from '@angular/router';
import { CircleGeofence, GeofencesAPIDataInterface, PolygonGeofence } from './interfaces';
import { DateUtils } from 'src/app/utils/days-utils';
import { isValidCoordinate } from 'src/app/utils/constants';
import { MapGeofenceRendererService } from '../../services/map-geofence-renderer.service';
// import { ThisReceiver } from '@angular/compiler';
interface MarkerLabel extends google.maps.ReadonlyMarkerLabel {
  labelOrigin: google.maps.Point;
}

declare var require: any;
declare var InfoBox: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);



@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('500ms ease-out', style({ transform: 'translateY(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ]
})

export class MapViewComponent implements OnInit, OnDestroy {
  imgSrc: string;
  Highcharts: typeof Highcharts = Highcharts;

  constructor(
    private commonService: CommonService, 
    private envService: EnvironmentService, 
    private activeRoute:ActivatedRoute,
    private geofenceRendererService: MapGeofenceRendererService
  ) { }
  socketRef: any;
  enableEmployeesDetails: boolean = false;
  employeesDetailsWithShuttleStops: any = []
  formControlValue = new UntypedFormControl("MOBILE");
  selectedActions: MultiSelectDropdownItem[] = [];
  actions: MultiSelectDropdownItem[] = [{ label: 'Vehicle Arrived', value: 'Vehicle Arrived' }, { label: 'Call Employee', value: 'Call Employee' }, { label: 'No Show', value: 'No Show' }];

  polyline: google.maps.Polyline;
  map: google.maps.Map | undefined;
  // lat=12.900342
  // lng=77.790047
  // coordinates = new google.maps.LatLng(this.lat, this.lng);
  signInLocationCheck: boolean = false;
  enableTraffic: boolean = false
  enableSpeed: boolean = false
  selectedRadioValue = "MOBILE"
  mapOptions: google.maps.MapOptions =
    {
      // center:this.coordinates,
      zoom: 20,
      mapTypeControl: false,
      streetViewControl: false,
    };
  speedOnCard: any = 0
  lastLocationUpdate: any;
  speedColor: any = '#F2FBFF';
  socketLastUpdateTime = null;
  middleStopsCordinates: any = []
  allCordinates: any = []
  firstStop: any;
  lastStop: any;
  vehicleMarker: google.maps.Marker | undefined | null;
  vehicleCurrentLocationCords: any;
  signInLocationGeoCords: any = []
  signInLocationMarkers: any = []
  noShowOnMapMarkers: any = []
  callEmployeesMarkersOnMap: any = []
  VehicleArrivedMarkersOnMap: any = []
  animationDuration: number = 3000;
  trafficLayer: google.maps.TrafficLayer;
  stops: any;
  driverActions: any;
  employeeDetails: any;
  sequenceId: any = 0
  polylineList = [];
  mileStones: google.maps.DirectionsWaypoint[] = []
  formattedWaypoints: any = []
  formattedWaypointsBreakLine: any = []
  mapOfCoordsAndSpeed: any
  speedForMilestones: any = []
  vehiclePreviousCoords: any = { lat: 0, lng: 0 }
  legUUID = "8dd30b60-82f6-456a-8c4e-1000b83bf299"
  IMEI = "f696599b970c3ce6"
  tripId = "";
  cabRegNum=""
  options;
  speed;
  response;
  actionsOpen = false;
  plannedRouteToggle = false;

  noShowAction = false;
  callEmployeeAction = false;
  vehicleArrivedAction = false;
  driverFixedDevice = false;
  planedRoutePath;
  currentStopIndex = 0;
  toolTip1;
  toolTip2;
  employeeInfo = false;
  isCompletedTrip = false;
  directionsRenderer = [];
  directionsService;
  routeConfig = [];
  infoBox;
  vehicleDetailsMarker = true;
  trackingInterval;
  timezone = 'Asia/Manila';


  //Adding geofences and virtual waypoints arrays
  geofenceToggle:boolean=false;
  virtualWayPointToggle:boolean=false;
  virtaulWayPoints:any=[];
  geofenceAPIData:any=[];


  ngOnInit(): void {
    this.setDefaultTab();
    this.imgSrc = this.envService.getImgSrc();
    this.legUUID = this.commonService.response.tripDetails.tripUuid
    this.IMEI = this.commonService.response.tripDetails.vehicle.deviceDTO?.imei
    this.cabRegNum=this.commonService.response.tripDetails.vehicle.vehicleIdentification
    this.response = this.commonService.response;
    this.geofenceAPIData=this.commonService['tripDetails']?.['geofences'];
    this.tripId = this.commonService.response.tripDetails.tripId;




    if (this.response['tripDetails']['status'] === 'Ended') {
      this.isCompletedTrip = true;
      const ele = document.getElementById('highCharts');
      ele.style.display = 'none';
    }
    this.getTrackingSession();
    this.commonService.getTimeZone().subscribe((res) => {

      this.commonService.timeZone = res['timeZone'];
      this.timezone = res['timeZone'];

    })

    this.trackingInterval = setInterval(() => {
      this.getTrackingSession();
    }, 45000);



    this.commonService.driverActions$.subscribe((res: any) => {
      this.driverActions = res
    })
    this.commonService.busStopsDetails$.subscribe((res: any) => {
      this.stops = res
      this.currentStopIndex = this.stops.findIndex((stop: any) => stop.actualArrivalTime === 0) - 1;
      if (this.response['tripDetails']['status'] !== 'Ended' && this.currentStopIndex >= 0) {
        const toolTip1content = `
        <div>
        <h3>${this.stops[this.currentStopIndex].address}</h3>
        <p>${this.stops[this.currentStopIndex].formattedPlannedArrivalTime} (+${this.stops[this.currentStopIndex].arrivalTimeDiffFormatted})</p>     
        </div>`;
        this.toolTip1 = new google.maps.InfoWindow({
          content: toolTip1content
        });
        const toolTip2content = `
        <div>
        <h3>${this.stops[this.currentStopIndex + 1].address}</h3>
        <p>ETA: ${this.stops[this.currentStopIndex + 1].formattedPlannedArrivalTime}</p>     
        </div>`;
        this.toolTip2 = new google.maps.InfoWindow({
          content: toolTip2content
        });
        this.toolTip1.open(this.map,)
      }
    })

    this.commonService.employeeDetails$.subscribe((res: any) => {
      this.employeeDetails = res
      console.log("employee details in Map", this.employeeDetails);
    })
    console.log("ein Map", this.stops);
    this.allCordinates = this.stops.map((stop: {
      geoCord: { split: (arg0: string) => [any, any] };
      employees: any;
      unPlannedEmployeesOnStop: any;
      stopLocalityId: any;
      stopAddress: any,
      plannedArrivalTime: any,
      actualArrivalTime: any,
      address: any,
      localityId: any

    }) => {
      const [lat, lng] = stop.geoCord.split(",");
      return {
        position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
        plannedEmployees: stop.employees,
        unplannedEmployees: stop.unPlannedEmployeesOnStop,
        actualArrivalTimeOfStop: stop.actualArrivalTime,
        plannedArrivalTimeOfStop: stop.plannedArrivalTime,
        address: stop.address,
        localityId: stop.localityId

      };
    });

    // Remove first and last stops from allCordinates


    this.middleStopsCordinates = this.allCordinates.slice(0, -1);

    this.firstStop = this.allCordinates[0];
    this.lastStop = this.allCordinates[this.allCordinates.length - 1];

    this.socketRef = create({
      port: 443,
      hostname: "sc.moveinsync.com",
      secure: true,
      autoReconnect: true,
      autoReconnectOptions: {
        initialDelay: 10000, //milliseconds
        randomness: 10000, //milliseconds
        multiplier: 1.5, //decimal
        maxDelay: 60000 //milliseconds
      },
    });
    const authListener = this.socketRef.listener("authStateChange").once();
    const connectListener = this.socketRef.listener("connect").once();
    connectListener.then(
      (data: { isAuthenticated: any }) => {
        if (!data.isAuthenticated) {
          this.socketRef.invoke("loginRequest", {
            username: "central-dashboard" + Math.random(),
            clientType: "mobileapp",
            organization: "central-dashboard",
          });
          console.log("Authenticated");
        } else {
          console.log("Connection established and authenticated with socket");
        }

      },
      (err: any) => {
        console.warn("error connecting socket >", err);
      }
    );

    this.subscribeToChannel()
      .then(() => {
        console.log("done");
      })
      .catch(() => {
        console.log("err");
      });

    //HighCharts
    this.options = {

      chart: {
        type: 'gauge',
        plotBackgroundColor: '#F2FBFF',
        plotBackgroundImage: '#F2FBFF',
        plotBorderWidth: 0,
        plotShadow: false,
        height: '60%'
      },

      title: {
        text: 'Last Updated: Just Now',
      },
      subtitle: {
        text: 'Speed:',
        useHTML: true
      },

      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '75%'],
        size: '110%'
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 200,
        tickPixelInterval: 72,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 15,
        tickWidth: 1,
        minorTickInterval: null,
        labels: {
          distance: 20,
          style: {
            fontSize: '12px'
          }
        },
        lineWidth: 0,
        plotBands: [{
          from: 0,
          to: 120,
          color: '#55BF3B', // green
          thickness: 10
        }, {
          from: 120,
          to: 160,
          color: '#DDDF0D', // yellow
          thickness: 10
        }, {
          from: 160,
          to: 200,
          color: '#DF5353', // red
          thickness: 10
        }]
      },

      series: [{
        name: 'Speed',
        data: [0],
        tooltip: {
          valueSuffix: ' km/h'
        },
        dataLabels: {
          format: '{y} km/h',
          borderWidth: 0,
          color: (
            Highcharts.defaultOptions.title &&
            Highcharts.defaultOptions.title.style &&
            Highcharts.defaultOptions.title.style.color
          ) || '#333333',
          style: {
            fontSize: '12px',
            fontWeight: 'normal'
          }
        },
        dial: {
          radius: '80%',
          backgroundColor: 'gray',
          baseWidth: 10,
          baseLength: '0%',
          rearLength: '0%'
        },
        pivot: {
          backgroundColor: 'gray',
          radius: 4
        }

      }]

    };
    Highcharts.chart('container', this.options);

    setInterval(() => {
      const chart = Highcharts.charts[0];
      if (chart && !chart.renderer['forExport']) {
        const point = chart.series[0].points[0],
            inc = this.speedOnCard;

        point.y = 0;
        const title = chart.title as any;

        // trip has not ended : show last updated time
        if (this.response['tripDetails']['status'] !== 'Ended') {
          title.textStr = 'Last Updated: ' + (this.lastLocationUpdate ?? 'Just Now');
          if(this.infoBox){
          this.updateInfoBoxContent();
        }
        }
        let newVal = point.y + (+inc);
        // if (newVal < 0 || newVal > 200) {
        //   newVal = point.y - inc;
        // }
        point.update(newVal);
      }

    }, 500);

  }

  checkFixedDeviceAvailability(){
    return !!this.commonService.response.tripDetails?.vehicle.externalDeviceImei
  }

  checkDriverDeviceAvailability(){
    return !!this.commonService.response.tripDetails?.vehicle.deviceDTO?.imei
  }

  async subscribeToChannel() {
    this.updateCabLocation(this.commonService.buid);
  }

  async updateCabLocation(buid: String) {
    var channelRef = this.socketRef.subscribe(this.IMEI);
    this.socketRef.listener("subscribe").once();
    for await (const socketData of channelRef) {
      if (socketData.message_type !== 'usercount') {
        let currentCords = { lat: socketData.data.la, lng: socketData.data.ln }
        if (this.vehiclePreviousCoords !== currentCords) {
          this.showSpeedTimeInfo(socketData.data.s)
          this.lastLocationUpdateOnCard(socketData.data.t)
          this.animatedMove(this.vehicleMarker, this.vehiclePreviousCoords, { lat: socketData.data.la, lng: socketData.data.ln }, socketData.data.b);
        }
        this.vehiclePreviousCoords = { lat: socketData.data.la, lng: socketData.data.ln }
        this.socketLastUpdateTime = socketData.data.t;
      }
    }
  }

  ngAfterViewInit() {
    this.mapInitializer()
    this.showPlannedRoute();
  }

  prevMarker = null; // variable to keep track of the previously clicked marker
  isPrevMarkerClicked = false;

  attachMarkerAndMessage(marker: google.maps.Marker, map: google.maps.Map) {
    let selectedMarker: google.maps.Marker | null = null;
    //  const attachSecretMessage = (marker: google.maps.Marker, map: google.maps.Map) => {
    marker.addListener("click", () => {
      if (selectedMarker) {
        // Unselect the previously selected marker
        console.log('selectedMarker1', selectedMarker);

        const markerIcon1 = {
          url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        const markerIcon2 = {
          url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        selectedMarker.setIcon(selectedMarker['data'].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1);
        this.employeesDetailsWithShuttleStops = []

      }
      if (selectedMarker === marker) {
        // If the same marker is clicked again, unselect it and clear the selectedMarker variable
        selectedMarker = null;
        console.log('selectedMarker2', marker);
        const markerIcon1 = {
          url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        const markerIcon2 = {
          url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(40, 40), // Size of the marker icon
          labelOrigin: new google.maps.Point(20, 20), // Position of the label (number) relative to the marker icon
        };

        marker.setIcon(selectedMarker['data'].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1);
        this.enableEmployeesDetails = false;
        this.employeesDetailsWithShuttleStops = []

        //  marker.setIcon("assets/icons/bus-stop-marker.svg");
      } else {
        // Select the new marker and update the selectedMarker variable
        this.employeesDetailsWithShuttleStops = []
        selectedMarker = marker;
        this.enableEmployeesDetails = true;
        this.employeesDetailsWithShuttleStops = marker.get("data")
        console.log("sjr",this.employeesDetailsWithShuttleStops)
        marker.setIcon(`${this.imgSrc}assets/icons/selected-marker-on-map.svg`);

        // Animate the map to the center of the clicked marker
        const position = marker.getPosition();
        if (position) {
          map.panTo(position);
        } else {
          console.error("Marker position is null or undefined");
        }
      }
    });
    // };
  }
  mapInitializer() {
    // this.mapOptions={
    //   center:{lat:this.firstStop.position.lat(),lng:this.firstStop.position.lng()},
    //   zoom: 10,
    //   styles: DAY_TIME_WISE_STYLES,
    //   mapTypeControl: false,
    //   streetViewControl: false,
    // 
    this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, this.mapOptions);
    this.trafficLayer = new google.maps.TrafficLayer();
    this.geofenceRendererService.initialize(this.map);

    //Toltip on marker to display Data
    let selectedMarker: google.maps.Marker | null = null;



    const attachSecretMessage = (marker: google.maps.Marker, map: google.maps.Map) => {
      marker.addListener("click", () => {
        if (selectedMarker) {
          // Unselect the previously selected marker
          console.log('selectedMarker1', selectedMarker);

          const markerIcon1 = {
            url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };

          const markerIcon2 = {
            url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };
          const markerIcon3 = {
            url: `${this.imgSrc}assets/icons/logout-office.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };

          selectedMarker.setIcon(selectedMarker['data'].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1);
          this.employeesDetailsWithShuttleStops = []

          this.enableEmployeesDetails = false;
        }
        if (selectedMarker === marker) {
          // If the same marker is clicked again, unselect it and clear the selectedMarker variable
          selectedMarker = null;
          console.log('selectedMarker2', marker);
          const markerIcon1 = {
            url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };

          const markerIcon2 = {
            url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };
          const markerIcon3 = {
            url: `${this.imgSrc}assets/icons/logout-office.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
            labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
          };

          if (marker?.['data']) {
            const firstStopAddress = this.response?.tripDetails?.shuttleStops?.[0]?.address;
            const isFirstStop =this.response?.tripDetails?.direction === 'OUT' && marker['data'].address === firstStopAddress;
            const isNotArrived =marker['data']?.actualArrivalTimeOfStop === 0;
            marker.setIcon(isFirstStop ? markerIcon3 : isNotArrived ? markerIcon2 : markerIcon1);
          } 
           this.enableEmployeesDetails = false;
          this.employeesDetailsWithShuttleStops = []
        } else {
          // Select the new marker and update the selectedMarker variable
          this.employeesDetailsWithShuttleStops = []
          selectedMarker = marker;
          this.enableEmployeesDetails = true;
          this.employeesDetailsWithShuttleStops = marker.get("data")
          const markerIcon1 = {
            url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(80, 80), // Size of the marker icon
            labelOrigin: new google.maps.Point(40, 30), // Position of the label (number) relative to the marker icon
          };

          const markerIcon2 = {
            url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(80, 80), // Size of the marker icon
            labelOrigin: new google.maps.Point(40, 30), // Position of the label (number) relative to the marker icon
          };
          const markerIcon3 = {
            url: `${this.imgSrc}assets/icons/logout-office.svg`, // URL to your custom marker icon image
            scaledSize: new google.maps.Size(80, 80), // Size of the marker icon
            labelOrigin: new google.maps.Point(40, 20), // Position of the label (number) relative to the marker icon
          };

          if (marker?.['data'] && selectedMarker?.['data']) {
             const isFirstStop =
              this.response?.tripDetails?.direction === 'OUT' &&
              marker['data'].address === this.response?.tripDetails?.shuttleStops?.[0]?.address;
             const isNotArrived = selectedMarker['data']?.actualArrivalTimeOfStop === 0;
             marker.setIcon( isFirstStop ? markerIcon3 : isNotArrived ? markerIcon2 : markerIcon1);
          }
          const position = marker.getPosition();
          if (position) {
            map.panTo(position);
          } else {
            console.error("Marker position is null or undefined");
          }
        }
      });
    };



    //Plotting Middle Stops
    for (let i = 0; i < this.middleStopsCordinates.length; i++) {
      // var icon1 = "assets/icons/bus-stop-marker1.svg";
      // var icon2= "assets/icons/stop-not-crossed-map1.svg";
      const markerIcon1 = {
        url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
        scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
        labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
      };

      const markerIcon2 = {
        url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
        scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
        labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
      };
      // if (i === 0) 
      // {
      //   icon = "assets/icons/green-stop-on-map.svg";
      // }
      console.log('middle stops', this.middleStopsCordinates[i]);
      let markerIcon3;
      if (this.response['tripDetails']['direction'] === 'OUT') {
        markerIcon3 = {
          url: `${this.imgSrc}assets/icons/logout-office.svg`, // URL to your custom marker icon image
          scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
          labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
        };
      }

      var marker = new google.maps.Marker(
        {
          position: this.middleStopsCordinates[i].position,
          map: this.map,
          icon:
            this.response['tripDetails']['direction'] === 'OUT' && i === 0 ? markerIcon3 :
              this.middleStopsCordinates[i].actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1,
          animation: google.maps.Animation.DROP,
          label: {
            text: '' + (i + 1), // The number to be displayed on the marker
            color: "#FFFFFF", // Color of the label (number)
            fontSize: "14px", // Font size of the label (number)
            fontWeight: "bold", // Font weight of the label (number)
          },
        }
      );
      var data = {
        plannedEmployees: this.middleStopsCordinates[i].plannedEmployees,
        unplannedEmployees: this.middleStopsCordinates[i].unplannedEmployees,
        address: this.middleStopsCordinates[i].address,
        actualArrivalTimeOfStop: DateUtils.formatTimeWithZone(this.middleStopsCordinates[i].actualArrivalTimeOfStop, this.commonService.timeZone, 'HH:mm'),
        plannedArrivalTimeOfStop: DateUtils.formatTimeWithZone(this.middleStopsCordinates[i].plannedArrivalTimeOfStop, this.commonService.timeZone, 'HH:mm'),
        localityId: this.middleStopsCordinates[i].localityId,
      };
      marker.set("data", data);
      console.log("marker unplanned data", data);
      attachSecretMessage(marker, this.map);

      if (this.response['tripDetails']['status'] !== 'Ended' && this.currentStopIndex >= 0) {
        let toolTip1content = ``;


        // console.log('arrival-tym', this.stops[this.currentStopIndex].arrivalTimeDiffFormatted);
        if (this.currentStopIndex >=0 && this.stops[this.currentStopIndex].arrivalTimeDiff > 0) {


          if (!!this.stops[this.currentStopIndex].arrivalTimeDiffFormatted) {
            toolTip1content = `<div>
            <h3>${this.stops[this.currentStopIndex].address}</h3>
            <p class="delay">${this.stops[this.currentStopIndex].formattedPlannedArrivalTime} (+${this.stops[this.currentStopIndex].arrivalTimeDiffFormatted})</p>     
            </div>`;
          } else {
            toolTip1content = `<div>
            <h3>${this.stops[this.currentStopIndex].address}</h3>
            <p class="delay">${this.stops[this.currentStopIndex].formattedPlannedArrivalTime}</p>     
            </div>`;
          }
          // toolTip1content = `<div>
          // <h3>${this.stops[this.currentStopIndex].address}</h3>
          // <p class="delay">${this.stops[this.currentStopIndex].formattedPlannedArrivalTime} (+${this.stops[this.currentStopIndex].arrivalTimeDiffFormatted})</p>     
          // </div>`;
          this.toolTip1.setContent(toolTip1content);

          //  toolTip12.classList.add("delay");
        }
        const toolTip2content = `
        <div>
        <h3>${this.stops[this.currentStopIndex + 1].address}</h3>
        <p>ETA: ${this.stops[this.currentStopIndex + 1].formattedPlannedArrivalTime}</p>     
        </div>`;
        this.toolTip1 = new google.maps.InfoWindow({
          content: toolTip1content,
        });
        this.toolTip2 = new google.maps.InfoWindow({
          content: toolTip2content
        });

        if (i === this.currentStopIndex) {
          this.toolTip1.open(this.map, marker);
        }

        if (i === (this.currentStopIndex + 1)) {
          console.log('marker2', toolTip2content);

          this.toolTip2.open(this.map, marker);
        }
      }



      // this.toolTip1.setOptions({
      //   maxWidth: 100, // Set maximum width
      //   backgroundColor: 'red', // Set background color
      //   borderRadius: '12px', // Set border radius
      //   padding: '8px 12px', // Set padding
      //   fontSize: '16px', // Set font size
      //   border: '1px solid #E0E0E0',
      //   boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.12)'

      //   // Add more custom CSS properties as needed
      // });




      // this.attachMarkerAndMessage(marker,this.map);
    }
    const trip = this.response?.tripDetails;
    const stopsLength = this.stops?.length ?? 0;
    let hasArrived = false;
    if (stopsLength > 0 && trip?.shuttleStops?.length > stopsLength - 1) {
      const lastArrivalTime =trip.shuttleStops[stopsLength - 1]?.actualArrivalTime;
      hasArrived = lastArrivalTime != null && lastArrivalTime !== 0;
    }
    //Ploting  Last Stop
    const lastMarkerIcon = {
      url:
      trip?.direction === 'OUT'
        ? trip?.status === 'Ended' && hasArrived
          ? `${this.imgSrc}assets/icons/bus-stop-marker1.svg`
          : `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`
        : `${this.imgSrc}assets/icons/office-marker.svg`,
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
    };
    // console.log('lastmarker', lastMarkerIcon, this.middleStopsCordinates.length, this.currentStopIndex);
    let lastMarker: google.maps.Marker | undefined;
    if (this.lastStop?.position) {
     lastMarker = new google.maps.Marker(
      {
        position: this.lastStop.position,
        map: this.map,
        icon: lastMarkerIcon,
        animation: google.maps.Animation.DROP,
        label: this.response['tripDetails']['direction'] === 'OUT' ? {
          text: '' + (this.middleStopsCordinates.length + 1), // The number to be displayed on the marker
          color: "#FFFFFF", // Color of the label (number)
          fontSize: "14px", // Font size of the label (number)
          fontWeight: "bold", // Font weight of the label (number)
        } : '',
      });
    }
    if (this.middleStopsCordinates.length === (this.currentStopIndex + 1) && this.response['tripDetails']['status'] !== 'Ended') {
      const toolTip2content = `
        <div>
        <h3>${this.stops[this.currentStopIndex + 1].address}</h3>
        <p>ETA: ${this.stops[this.currentStopIndex + 1].formattedPlannedArrivalTime}</p>     
        </div>`;
      this.toolTip2 = new google.maps.InfoWindow({
        content: toolTip2content
      });
      // add click listener to last marker
    if (lastMarker) {
      this.toolTip2.open(this.map, lastMarker);
      lastMarker.addListener("click", () => {
        this.toolTip2.open(this.map, lastMarker);
      });
    }
      // close the tooltip when the map is clicked
      this.map.addListener("click", () => {
        this.toolTip2.close();
      });
      
    } else {

    }


  }
  openTooltip(marker) {
    marker.infoWindow.open(this.map, marker);
    // this.toolTip1.setPosition(marker.getPosition());
  }

  async getTrackingSession() {
    //creating polyline at first time
    this.commonService.getTrackingSession(this.legUUID, this.sequenceId, this.IMEI, this.selectedRadioValue, this.isCompletedTrip, this.driverFixedDevice, this.tripId).subscribe((res: any) => {

      let bearing = res.cabLocation?.mBearing
      this.speed = res.cabLocation?.mSpeed
      let updatedTime = res.cabLocation?.time
      this.sequenceId = res?.sequenceId
      this.vehicleCurrentLocationCords = new google.maps.LatLng(res.cabLocation?.latitude, res.cabLocation?.longitude);
      let current = { lat: res.cabLocation?.latitude, lng: res.cabLocation?.longitude }
      this.lastLocationUpdateOnCard(updatedTime)
      if (!res.milestones) {
        res.milestones = [];
      }
      this.formattedWaypoints = res.milestones.map((obj: any) => new google.maps.LatLng(obj.latitude, obj.longitude));
      let breaklineCoords = res.milestones.map(
        (obj: any) => {
          return {
            loc: new google.maps.LatLng(obj.latitude, obj.longitude),
           // timeStamp: obj.timeStamp,
            mSpeed: obj.mSpeed,
            timeStamp: DateUtils.parseToTimeZone(obj.time, this.timezone)
          }
        }
      );
      for (let i = 0; i < breaklineCoords.length; i++) {
        this.formattedWaypointsBreakLine.push(breaklineCoords[i]);
      }

      if (this.vehicleMarker == null) {
        this.vehiclePreviousCoords = { lat: this.vehicleCurrentLocationCords.lat(), lng: this.vehicleCurrentLocationCords.lng() }
        const busImage = {
          url: `${this.imgSrc}assets/icons/bus-on-map.svg` + "#" + this.IMEI,
          scaledSize: new google.maps.Size(40, 40),
          anchor: new google.maps.Point(13, 13),
        };

        var boxText = `<div style="background: white;
        padding: 10px 0 10px 10px;
        width: max-content;
        border-radius: 10px;
        position: absolute;
        top: -50px;
        left: 10px;
        display:flex;
        gap:5px">
          <div style="display:flex;flex-direction:column">
          <span style="font-size:14px">Bus Number: ${this.response.tripDetails.vehicle.vehicleIdentification}</span>
          <span style="font-size:14px">Driver: ${this.response.tripDetails.driver?.name}</span>
          ${this.response['tripDetails']['status'] !== 'Ended' ? 
          `<span style="font-size:14px">Last Updated : ${ (this.lastLocationUpdate ?? 'Just Now') }</span>` : ''}
          </div>
          <img style="margin-top:-30px;cursor:pointer"  id="vehicleClose" src="${this.imgSrc}assets/icons/cross-icon.svg" />
           
         </div>`;
        var myOptions = {
          content: boxText,
          disableAutoPan: false,
          maxWidth: 0,
          pixelOffset: new google.maps.Size(-10, -10),
          zIndex: 2,
          boxStyle: { top: -10, left: -10 },
          closeBoxMargin: "",
          closeBoxURL: "",
          infoBoxClearance: new google.maps.Size(0, 0),
          isHidden: false,
          pane: "floatPane"
        };
        this.vehicleMarker = new google.maps.Marker(
          {
            position: this.isCompletedTrip ? this.lastStop?.position: this.vehicleCurrentLocationCords,
            map: this.map,
            icon: busImage
          });
        this.infoBox = new InfoBox(myOptions);
        //empMarker.marker.infoBox = infoBox;


        this.vehicleMarker.addListener('click', () => {
          // Open the InfoBox
          if (this.vehicleDetailsMarker) {
            this.infoBox.open(this.map, this.vehicleMarker);
            // this.vehicleDetailsMarker=false;
          } else {
            // this.infoBox.close();
            // this.vehicleDetailsMarker=true;
          }
        });
        this.infoBox.addListener('domready', () => {
          const infoBoxElement = document.getElementById('vehicleClose');
          // Add your click event logic here
          infoBoxElement.addEventListener('click', () => {
            // Your click event code
            this.infoBox.close();
          });
        });




        this.map?.setCenter(this.vehicleCurrentLocationCords);
        this.map?.setZoom(13);

        setTimeout(() => {
          let elemSel = document.querySelector(
            'img[src*="bus-on-map.svg"]'
          ) as HTMLElement;
          

          if (elemSel && bearing != null) {
            elemSel.style.transform = `rotate(${bearing}deg)`;
          }
        }, 1000)
      } else {
        if (this.socketLastUpdateTime == null || this.socketLastUpdateTime < res.cabLocation?.time) {
          this.showSpeedTimeInfo(this.speed)
          this.lastLocationUpdateOnCard(updatedTime)
          this.animatedMove(this.vehicleMarker, this.vehiclePreviousCoords, current, bearing);
          this.vehiclePreviousCoords = current
        }
      }
      this.plottingPolyLine(this.map)
    })
  }
  updateInfoBoxContent() {
    const newBoxText = `
      <div style="background: white;
      padding: 10px 0 10px 10px;
      width: max-content;
      border-radius: 10px;
      position: absolute;
      top: -50px;
      left: 10px;
      display:flex;
      gap:5px">
        <div style="display:flex;flex-direction:column">
          <span style="font-size:14px">Bus Number: ${this.response.tripDetails.vehicle.vehicleIdentification}</span>
          <span style="font-size:14px">Driver: ${this.response.tripDetails.driver?.name}</span>
           <span style="font-size:14px">Last Updated : ${ (this.lastLocationUpdate ?? 'Just Now') }</span>
        </div>
        <img style="margin-top:-30px;cursor:pointer" id="vehicleClose" src="${this.imgSrc}assets/icons/cross-icon.svg" />
      </div>`;
  
    // Update the InfoBox content
    this.infoBox.setContent(newBoxText);
  
    // Reattach event listener for the close button
    setTimeout(() => {
      const infoBoxElement = document.getElementById('vehicleClose');
      if (infoBoxElement) {
        infoBoxElement.addEventListener('click', () => {
          this.infoBox.close();
        });
      }
    }, 0);
  }
  


  async animatedMove(
    marker: any,
    current: { lat: any; lng: any },
    moveto: { lat: number; lng: number },
    bearing: any
  ) {

    if (!marker || !isValidCoordinate(current.lat, current.lng) || !isValidCoordinate(moveto.lat, moveto.lng)) return;

    var imgIcon = marker.getIcon();
    if(imgIcon) {
      imgIcon.rotation = bearing;
      marker.setIcon(imgIcon);
    }
    var nxlat = moveto.lat;
    var nxlng = moveto.lng;
    var deltalat = (moveto.lat - current.lat) / 100;
    var deltalng = (moveto.lng - current.lng) / 100;
    for (var i = 0; i < 100; i++) {
      (function (ind) {
        setTimeout(function () {
          var newLat = marker.position.lat();
          var newLng = marker.position.lng();
          newLat += deltalat;
          newLng += deltalng;

          marker.setPosition({ lat: newLat, lng: newLng });
        }, 10 * ind);
      })(i);
    }
    marker.setValues({ lat: nxlat, lng: nxlng });
    let elemSel = document.querySelector(
      'img[src*="bus-on-map.svg"]'
    ) as HTMLElement;
    if (elemSel && bearing != null && bearing != 0) {
      elemSel.style.transform = `rotate(${bearing}deg)`;
    }
  }

  enableSpeedPolyline() {
    this.enableSpeed = !this.enableSpeed
    if (this.enableSpeed) {
      if (this.polyline) {
        this.polyline.setVisible(false);
      }
      this.drawPathWithSpeed(this.formattedWaypointsBreakLine, this.map)
    }
    else {
      for (let i = 0; i < this.polylineList.length; i++) {
        this.polylineList[i].setMap(null);
      }
      this.polylineList = []
      if (this.polyline) {
        this.polyline.setVisible(true);
      }
    }
  }
  lastLocationUpdateOnCard(time: any) {
    const currentTime = new Date().getTime(); // Get current time in milliseconds
    const timeDifferenceMinutes = Math.floor((currentTime - time) / (1000 * 60)); // Calculate the time difference in minutes

    if (timeDifferenceMinutes >= 0) {
      if (timeDifferenceMinutes === 0) {
        this.lastLocationUpdate = 'Just now';
      } else if (timeDifferenceMinutes <= 60) {
        this.lastLocationUpdate = `${timeDifferenceMinutes} min ago`;
      } else {
        const timeDifferenceHours = Math.floor(timeDifferenceMinutes / 60); // Calculate the time difference in hours
        const remainingMinutes = timeDifferenceMinutes % 60; // Calculate the remaining minutes

        if (remainingMinutes === 0) {
          this.lastLocationUpdate = `${timeDifferenceHours} hr ago`;
        } else {
          this.lastLocationUpdate = `${timeDifferenceHours} hr ${remainingMinutes} mins ago`;
        }
      }
    }
  }
  showSpeedTimeInfo(speed) {

    this.speedOnCard = (speed * 3.6).toFixed(1)

    this.speedColor = '#F1FDF8';
    if (speed * 3.6 < 1) {
      this.speedColor = '#FAE1EA';
    }
  }

  plottingPolyLine(map: any) {
    this.polyline = new google.maps.Polyline({
      path: this.formattedWaypoints,
      geodesic: true,
      strokeColor: '#40447F',
      strokeOpacity: 1.0,
      strokeWeight: 2.5,
    });
    this.polyline.setMap(map);
  }

  drawPathWithSpeed(timeLocs, map) {
    for (let k = 0; k < timeLocs.length - 1; k++) {
      for (let m = k + 1; m < timeLocs.length; m++) {
        if (!timeLocs[k] || !timeLocs[m]) {
          break;
        }
        const path = [];
        path[0] = timeLocs[k].loc;
        path[1] = timeLocs[m].loc;

       // console.log('speed',timeLocs[m].mSpeed);

        const polylineOptions = {
          clickable: true,
          map: map,
          strokeColor: '#40447F',
          strokeOpacity: 1.0,
          strokeWeight: 2,
          path: path,
          time: timeLocs[m].timeStamp,
          speed: (timeLocs[m].mSpeed).toFixed(2),
        };
        this.polylineList.push(new google.maps.Polyline(polylineOptions));
        this.setPolyLineClickListener(this.polylineList[this.polylineList.length - 1]);
        k = m - 1;
        break;
      }
    }
  }


  setPolyLineClickListener(polyline) {
    const infoWindow = new google.maps.InfoWindow();
    const icon = {
      url: `${this.imgSrc}assets/icons/marker-on-polyline.svg`,
      scaledSize: new google.maps.Size(20, 20), // Adjust the size of the icon as needed
    };
    const marker = new google.maps.Marker({
      icon: icon,
      map: this.map,
      visible: false,
    });

    google.maps.event.addListener(polyline, 'mouseover', function (e) {

      if (!polyline.time) {
        return false;
      }

      const date = DateUtils.parseDateString(polyline.time, 'DD/MM/YYYY HH:mm:ss');
      const content = `
      <div class="d-flex flex-dir-col gap-4" style="padding: 2px;">
        <span> ${date.format('DD, MMMM, h:mm A')} </span>
        <span>Speed: ${(polyline.speed * 3.6).toFixed(1)} km/hr</span>
      </div>
    `;

      infoWindow.setContent(content);
      infoWindow.setPosition(e.latLng);
      infoWindow.setOptions({
        pixelOffset: new google.maps.Size(0, -30),

      });
      marker.setVisible(true);
      marker.setPosition(e.latLng);

      infoWindow.open(this.map);

      return true;
    });
    google.maps.event.addListener(polyline, 'mousemove', function (e) {
      marker.setVisible(true);
      marker.setPosition(e.latLng);
    });
    google.maps.event.addListener(polyline, 'mouseout', function (e) {
      infoWindow.close();
      marker.setVisible(false);
    });
  }
 

  plotGeofencePoints(geofencesAPIData: GeofencesAPIDataInterface) {    
    this.geofenceRendererService.plotGeofencePoints(geofencesAPIData);
  }

  showGeofences() {
    this.geofenceToggle = !this.geofenceToggle;
  
    if (this.geofenceToggle) {
      this.plotGeofencePoints(this.geofenceAPIData ?? {});
    } else {
      this.geofenceRendererService.clearGeofences();
    }
  }

  plotVirtualWayPoints(virtualWayPoints: any) { 
    this.geofenceRendererService.plotVirtualWayPoints(virtualWayPoints ?? {});
  }
  
  showVirtualWaypoints(){
    this.virtualWayPointToggle = !this.virtualWayPointToggle;

    if (this.virtualWayPointToggle) {
      this.plotVirtualWayPoints(this.commonService.response?.tripDetails?.virtualWayPoints);
    } else {
      this.geofenceRendererService.clearVirtualWayPoints();
    }
  }

  plotSignInLocationMarkers() {
    const signInLocationGeoCordsMap = this.employeeDetails
    
      .filter((employee: any) => employee.actualPickupTime !== 0 && employee.actualPickupLocation.geocord !== null) // skip stops where actualPickupTime is null
      .map((employee: any) => {
        const [lat, lng] = employee.actualPickupLocation.geocord.split(",");
        return {
          position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
          name: employee?.name,
          status: employee?.employeeTrackStatus,
          empId: employee?.Id,
          pickUp: employee?.signIn,
          signInLocation: employee?.actualPickupLocation?.address,
          plannedLocation: employee?.plannedPickupLocation?.address,
          empStatus: employee.empStatus
        };
      })
      .sort((a: any, b: any) => a.signIn - b.signIn);

    const icon = {
      url: `${this.imgSrc}assets/icons/signInLocation.svg`,
      scaledSize: new google.maps.Size(50, 50),
      labelOrigin: new google.maps.Point(25, 19)
    };

    let openTooltip: any = null; // define openTooltip outside the loop

    // Create a custom tooltip for each marker
    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip");
    const infowindow = new google.maps.InfoWindow({
      zIndex: 999
    });

    let activeMarker: any;

    for (let i = 0; i < signInLocationGeoCordsMap.length; i++) {
      const marker = new google.maps.Marker({
        position: signInLocationGeoCordsMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
        label: {
          text: (i + 1).toString(),
          color: '#035F6B',
          fontSize: '12px',
          fontWeight: 'bold',
          fontFamily: 'Lato',
          labelOrigin: new google.maps.Point(25, 15) // Adjust to center label
        } as MarkerLabel
      });



      //   if (signInLocationGeoCordsMap[i].empStatus == 'ADHOC') {
      //     tooltip.innerHTML = `
      //   <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
      //       <span class="adhoc-color">Adhoc Employee</span>
      //     </div>
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
      //       <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
      //       <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
      //     </div>
      //   </div>
      // `;
      //   }
      //   if (signInLocationGeoCordsMap[i].empStatus == 'DIFFERENT_SIGNIN_LOCATION') {
      //     tooltip.innerHTML = `
      //   <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
      //       <span class="different-sign-in-color">Different Sign-In Location</span>
      //     </div>
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
      //       <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
      //       <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
      //       <span class="h7">Planned:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
      //     </div>
      //   </div>
      // `;
      //   }
      //   if (signInLocationGeoCordsMap[i].empStatus == 'PLANNED') {
      //     tooltip.innerHTML = `
      //   <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
      //       <span class="planned-color">Planned</span>
      //     </div>
      //     <div class="d-flex flex-dir-col">
      //       <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
      //       <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
      //       <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
      //       <span class="h7">Planned:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
      //     </div>
      //   </div>
      // `;
      //   }

      // Add the tooltip to the marker on click event
      marker.addListener('click', (res) => {
        if (signInLocationGeoCordsMap[i].empStatus == 'ADHOC') {
          tooltip.innerHTML = `
        <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
          <div class="d-flex flex-dir-col">
            <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
            <span class="adhoc-color">Adhoc Employee</span>
          </div>
          <div class="d-flex flex-dir-col">
            <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
            <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
            <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
          </div>
        </div>
      `;
        }
        if (signInLocationGeoCordsMap[i].empStatus == 'DIFFERENT_SIGNIN_LOCATION') {
          tooltip.innerHTML = `
        <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
          <div class="d-flex flex-dir-col">
            <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
            <span class="different-sign-in-color">Different Sign-In Location</span>
          </div>
          <div class="d-flex flex-dir-col">
            <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
            <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
            <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
            <span class="h7">Planned:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
          </div>
        </div>
      `;
        }
        if (signInLocationGeoCordsMap[i].empStatus == 'PLANNED') {
          tooltip.innerHTML = `
        <div class="sign-in-employees-tooltip d-flex flex-dir-col gap-8">
          <div class="d-flex flex-dir-col">
            <span class="h7-b">${signInLocationGeoCordsMap[i]?.name}</span>
            <span class="planned-color">Planned</span>
          </div>
          <div class="d-flex flex-dir-col">
            <span class="h7">Employee ID:&nbsp;${signInLocationGeoCordsMap[i].empId}</span>
            <span class="h7">Pick up:&nbsp;${signInLocationGeoCordsMap[i].pickUp}</span>
            <span class="h7">Signed In:&nbsp;${signInLocationGeoCordsMap[i].signInLocation}</span>
            <span class="h7">Planned:&nbsp;${signInLocationGeoCordsMap[i].plannedLocation}</span>
          </div>
        </div>
      `;
        }
        console.log('marker res', res.domEvent);

        if (activeMarker === marker) {
          infowindow.close();
          activeMarker = null;
          return;

        }

        // if (openTooltip && openTooltip.marker === marker) {
        //   infowindow.close();
        //   openTooltip = null;
        // }
        // else {
        // Create a new tooltip and open it
        activeMarker = marker;
        infowindow.setContent(tooltip);
        infowindow.open(this.map, marker);
        // Set the current open tooltip to this marker and tooltip
        //  openTooltip = { marker, infowindow };
        // }
      });
      this.signInLocationMarkers.push(marker);
    }
  }


  removeSignInLocationMarkers() {
    for (let i = 0; i < this.signInLocationMarkers.length; i++) {
      this.signInLocationMarkers[i].setMap(null);
    }
    this.signInLocationMarkers = [];
  }


  employeesDetailsToggler() {
    this.enableEmployeesDetails = !this.enableEmployeesDetails
  }


  onClosePopup(d: { value: boolean, data: any }) {
    this.enableEmployeesDetails = d.value;
    console.log('marker data', d);
    const markerIcon1 = {
      url: `${this.imgSrc}assets/icons/bus-stop-marker1.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
    };

    const markerIcon2 = {
      url: `${this.imgSrc}assets/icons/stop-not-crossed-map1.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(30, 20), // Position of the label (number) relative to the marker icon
    };
    const stop = this.middleStopsCordinates.filter((item) => { item.address === d.data.address });

    var marker = new google.maps.Marker(
      {
        position: stop.position,
        map: this.map,
        icon: stop.actualArrivalTimeOfStop === 0 ? markerIcon2 : markerIcon1,
        animation: google.maps.Animation.DROP,
        label: {
          text: '' + 1, // The number to be displayed on the marker
          color: "#FFFFFF", // Color of the label (number)
          fontSize: "14px", // Font size of the label (number)
          fontWeight: "bold", // Font weight of the label (number)
        },
      }
    );


  }
  enableTafficToggler() {
    this.enableTraffic = !this.enableTraffic;

    if (this.enableTraffic) {
      this.trafficLayer.setMap(this.map);
    } else {
      this.trafficLayer.setMap(null);
    }
  }

  showPlannedRoute() {
    this.plannedRouteToggle = !this.plannedRouteToggle;

    if (this.plannedRouteToggle) {
      this.plotPlannedRoute();
    } else {
      this.removePlannedRoute();
    }
  }

  showSignInLocationToggler() {
    this.signInLocationCheck = !this.signInLocationCheck;
    if (this.signInLocationCheck) {
      this.plotSignInLocationMarkers();
    } else {
      this.removeSignInLocationMarkers();
    }
  }

  radioSelect(value: any) {
    this.selectedRadioValue = value
  }

  selectedItems(values: any) {
    const previousSelection = this.selectedActions;
    this.selectedActions = values;

    // Remove markers for previously selected values that are not selected anymore
    previousSelection.forEach((action) => {
      if (!this.selectedActions.some(newAction => newAction.value === action.value)) {
        switch (action.value) {
          case 'No Show':
            this.removeNoShowMarkersOnMap();
            break;
          case 'Vehicle Arrived':
            this.removeVehicleArrivedMarkersOnMap();
            break;
          case 'Call Employee':
            this.removeplotCallEmployeeMarkersOnMap();
            break;
          default:
            break;
        }
      }
    });

    // Add markers for newly selected values
    this.selectedActions.forEach((action) => {
      switch (action.value) {
        case 'No Show':
          this.plotNoShowMarkerOnMap();
          break;
        case 'Vehicle Arrived':
          this.plotVehicleArrivedMarkersOnMap();
          break;
        case 'Call Employee':
          this.plotCallEmployeeMarkersOnMap();
          break;
        default:
          break;
      }
    });
  }

  unselectedValue(value) {
    switch (value) {
      case 'No Show':
        this.noShowAction = false;
        this.removeNoShowMarkersOnMap();
        break;
      case 'Vehicle Arrived':
        this.vehicleArrivedAction = false;
        this.removeVehicleArrivedMarkersOnMap();
        break;
      case 'Call Employee':
        this.callEmployeeAction = false;
        this.removeplotCallEmployeeMarkersOnMap();
        break;
      default:
        break;
    }
  }

  selectedValue(value) {
    switch (value) {
      case 'No Show':
        this.noShowAction = true;
        this.plotNoShowMarkerOnMap();
        break;
      case 'Vehicle Arrived':
        this.vehicleArrivedAction = true;
        this.plotVehicleArrivedMarkersOnMap();
        break;
      case 'Call Employee':
        this.callEmployeeAction = true;
        this.plotCallEmployeeMarkersOnMap();
        break;
      case 'Fixed Device':
        this.selectedRadioValue = "FIXED_DEVICE";
        this.driverFixedDevice = true;
       
        if(this.vehicleMarker){
          this.vehicleMarker.setMap(null);
          this.vehicleMarker=null;
        }
        if(this.polyline){
          this.polyline.setMap(null);
        }
        this.getTrackingSession()
        break;
      case 'Driver App':
        this.selectedRadioValue = 'MOBILE';
        this.driverFixedDevice = false;
        if(this.vehicleMarker){
          this.vehicleMarker.setMap(null);
          this.vehicleMarker=null;
        }
        if(this.polyline){
          this.polyline.setMap(null);
        }
        this.getTrackingSession()
        break;
      default:
        break;
    }
  }


  plotNoShowMarkerOnMap() {
    // Extract all the geoCode values
    const noShowGeoCodesMap = (this.driverActions.noShowDriverActions || []).map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName, employeeId: obj.empId, markedAt: DateUtils.formatTime(obj.markedAt, "hh:mm"),  plannedAt: obj.plannedLocation.address, markedBy: obj.markedBy };
    });
    console.log("mapping object", noShowGeoCodesMap);

    const icon = {
      url: `${this.imgSrc}assets/icons/no-show-on-map.svg`,
    };
    for (let i = 0; i < noShowGeoCodesMap.length; i++) {
      const marker = new google.maps.Marker({
        position: noShowGeoCodesMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      let openTooltip: any = null;
      // Create a custom tooltip for each marker
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
      <div class="no-show-tooltip d-flex flex-dir-col gap-8">
      <div class="d-flex flex-dir-col">
          <span class="h7-b">${noShowGeoCodesMap[i].empName}</span>
          <span class="red">No Show</span>
      </div>
      <div class="d-flex flex-dir-col">
          <span class="h7">Employee ID:${noShowGeoCodesMap[i]?.employeeId}</span>
          <span class="h7">Marked at:${noShowGeoCodesMap[i]?.markedAt}</span>
          <span class="h7">Planned at:${noShowGeoCodesMap[i]?.plannedAt}</span>
          <span class="h7">Marked by:${noShowGeoCodesMap[i]?.markedBy}</span>
      </div>
    </div>
      `;

      // Add the tooltip to the marker on click event
      marker.addListener('click', () => {
        // Check if a tooltip is already open and close it if it's the same marker
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        } else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });
      this.noShowOnMapMarkers.push(marker);
    }
  }

  plotPlannedRoute() {
    this.directionsRenderer.forEach((item) => {
      item.setMap(null);
    })
    this.directionsRenderer = [];

    const polylineOptions = {
      strokeColor: '#CC006B',
        strokeOpacity: 0,
        zIndex: 1,
        icons: [{
          icon: {
            path: 'M 0,-1 0,1',
            strokeOpacity: 1,
            strokeWeight: 2,
            scale: 3
          },
          offset: '0',
          repeat: '15px'
        }],
    }
    

    const encodedPolyline = this.commonService.response.tripDetails.encodedPolyline;
    if(encodedPolyline){
      const decodedPolyline = google.maps.geometry.encoding.decodePath(encodedPolyline);
      const bounds = new google.maps.LatLngBounds();
      decodedPolyline.forEach((point) => {
        bounds.extend(point);
      });
      const polyline = new google.maps.Polyline({
        path: decodedPolyline,
        ...polylineOptions,
        map: this.map
      })
      this.directionsRenderer.push(polyline);
      this.map.fitBounds(bounds);
      return;
    }
      this.commonService.busStopsDetails$.subscribe((res) => {
      console.log('shuttle plan', res);
      this.routeConfig = [];
      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer.push(new google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true,
        polylineOptions: polylineOptions
      }));
      res.forEach((stop) => {
        const lat = stop.geoCord.split(',')[0]
        const lng = stop.geoCord.split(',')[1]
        this.routeConfig.push({ lat: lat, lng: lng });
      })
      console.log('comfiig', this.routeConfig);

      const waypointsData = this.routeConfig.map((waypoint) => ({
        location: new google.maps.LatLng(waypoint.lat, waypoint.lng)
      }));
      const origin = waypointsData[0];
      const dest = waypointsData[waypointsData.length - 1];
      waypointsData.shift();
      waypointsData.pop();

      const request = {
        origin: origin,
        destination: dest,
        waypoints: waypointsData,
        travelMode: google.maps.TravelMode.DRIVING,
        optimizeWaypoints: true, // Optimize the route to follow roads
      };
      const _this = this;
      this.directionsService.route(request, function (response, status) {
        if (status === 'OK') {
          _this.draw(response);
        } else {
          console.log('Directions request failed. Status:', status);
        }
      });
    });
  }

  calculateRoute(coOr) {

    for (let i = 1; i < coOr.length; i++) {
      const request = {
        origin: coOr[i - 1], // Start point
        destination: coOr[i], // End point
        travelMode: google.maps.TravelMode.DRIVING, // Use driving directions
      };
      const _this = this;
      // Request the directions
      this.directionsService.route(request, function (response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          _this.draw(response);
        }
      });
    }

  }
  draw(res) {
    // for (let i = 0; i < legs.length; i++) {
    //   const steps = legs[i].steps;

    //   for (let j = 0; j < steps.length; j++) {
    //     const polyline = new google.maps.Polyline({
    //       path: steps[j].path,
    //       strokeColor: '#10ADAE',
    //       strokeOpacity: 0,
    //       strokeWeight: 8,
    //       icons: [{
    //         icon: {
    //           path: 'M 0,-2 0,2',
    //           strokeOpacity: 1,
    //           scale: 3,
    //         },
    //         offset: '0',
    //         repeat: '30px', // Set the distance between dashes
    //       }],
    //       map: this.map,
    //     });
    //   }

    this.directionsRenderer[0].setDirections(res);
    // }




    // const polylineOptions = {

    //   strokeColor: "#0000FF",
    //   strokeOpacity: 0.8,
    //   strokeWeight: 4,
    //   icons: [{
    //     icon: {
    //       path: 'M 0,-1 0,1',
    //       strokeOpacity: 1,
    //       scale: 4,
    //     },
    //     offset: '0',
    //     repeat: '20px', // Set the distance between dashes
    //   }],
    // };
    // const rendererOptions = {
    //   draggable: false,
    //   map: this.map,
    //   suppressMarkers: true,
    //   suppressInfoWindows: true,
    //   preserveViewport: true,
    //   suppressBicyclingLayer: true,
    //   polylineOptions
    // };
    // const directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);
    // directionsDisplay.setDirections(route);

    // this.planedRoutePath.push(directionsDisplay);
  }


  removePlannedRoute() {

    console.log(typeof (this.directionsRenderer));

    if (this.directionsRenderer) {
      this.directionsRenderer[0].setMap(null);
    }
    // this.planedRoutePath=null;
  }

  plotCallEmployeeMarkersOnMap() {
    // Extract all the geoCode values
    const callEmployeesGeoCodesMap = Array.isArray(this.driverActions.callEmployeeDriverActions) ?
    this.driverActions.callEmployeeDriverActions?.
    filter((obj: any) => obj && obj.geoCode)
    ?.map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName, empId: obj.empId, 
        pickUp: DateUtils.formatTime(obj.pickUpTime, "hh:mm"), callNumber: obj.phoneNumber, 
        callStart: DateUtils.formatTime(obj.callStartTime, "hh:mm"), callDuration: obj.callDuration, callStatus: obj.callStatus };
    }) : [];
    console.log("call employees", callEmployeesGeoCodesMap);

    const icon = {
      url: `${this.imgSrc}assets/icons/call-employee-marker-on-map.svg`,
    };

    for (let i = 0; i < callEmployeesGeoCodesMap.length; i++) {
      const marker = new google.maps.Marker({
        position: callEmployeesGeoCodesMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      // Create a custom tooltip for each marker
      let openTooltip: any = null;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
        <div class="call-employee-tool-tip d-flex flex-dir-col gap-8">
        <div class="d-flex flex-dir-col">
            <span>${callEmployeesGeoCodesMap[i].empName}</span>
            <span>${callEmployeesGeoCodesMap[i].callStatus}</span>
        </div>
        <div class="d-flex flex-dir-col">
            <span>Employee ID:${callEmployeesGeoCodesMap[i].empId}</span>
            <span>Pickup:${callEmployeesGeoCodesMap[i].pickUp}</span>
            <span>Call number:${callEmployeesGeoCodesMap[i].callNumber}</span>
            <span>Call Start:${callEmployeesGeoCodesMap[i].callStart}</span>
            <span>Call Duration:${callEmployeesGeoCodesMap[i].callDuration}</span>
        </div>
     </div>
        `;
      marker.addListener('click', () => {
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        }
        else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });

      this.callEmployeesMarkersOnMap.push(marker);
    }
  }



  plotVehicleArrivedMarkersOnMap() {
    // Extract all the geoCode values
    const arrivedActions = Array.isArray(this.driverActions?.vehicleArrivedDriverActions)
    ? this.driverActions?.vehicleArrivedDriverActions
    : [];
    const VehicleArrivedMarkersOnMap = arrivedActions
    ?.filter((obj: any) => obj && obj.geoCode)
    .map((obj: any) => {
      const [lat, lng] = obj.geoCode.split(",");
      const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));
      return { position, empName: obj.empName,vehicleArrived: DateUtils.formatTime(obj.vehicleArrivalTime, "hh:mm"), status: obj.vehicleStatusWithTime };
    });

    // const icon = {
    //   url: 'assets/icons/vehicle-arrived-marker-on-map.svg',
    // };
    const icon = {
      url: `${this.imgSrc}assets/icons/vehicle-arrived-marker-on-map.svg`, // URL to your custom marker icon image
      scaledSize: new google.maps.Size(60, 60), // Size of the marker icon
      labelOrigin: new google.maps.Point(40, 40), // Position of the label (number) relative to the marker icon
    };
    for (let i = 0; i < VehicleArrivedMarkersOnMap.length; i++) {
      const marker = new google.maps.Marker({
        position: VehicleArrivedMarkersOnMap[i].position,
        map: this.map,
        icon: icon,
        animation: google.maps.Animation.DROP,
      });
      // Create a custom tooltip for each marker
      let openTooltip: any = null;
      const tooltip = document.createElement("div");
      tooltip.classList.add("tooltip");
      tooltip.innerHTML = `
        <div class="vehicle-arrived-tooltip d-flex flex-dir-col gap-8">
        <span>${VehicleArrivedMarkersOnMap[i].status}</span>
        <span>Vehicle arrived at ${VehicleArrivedMarkersOnMap[i].vehicleArrived}</span>
        </div>
        `;

      marker.addListener('click', () => {
        if (openTooltip && openTooltip.marker === marker) {
          openTooltip.infowindow.close();
          openTooltip = null;
        }
        else {
          // Create a new tooltip and open it
          const infowindow = new google.maps.InfoWindow({
            content: tooltip,
          });
          infowindow.open(this.map, marker);
          // Set the current open tooltip to this marker and tooltip
          openTooltip = { marker, infowindow };
        }
      });
      this.VehicleArrivedMarkersOnMap.push(marker);
    }
  }

  removeNoShowMarkersOnMap() {
    if (this.noShowOnMapMarkers) {
      for (let i = 0; i < this.noShowOnMapMarkers.length; i++) {
        this.noShowOnMapMarkers[i].setMap(null);
      }
      this.noShowOnMapMarkers = [];
    }
  }

  removeVehicleArrivedMarkersOnMap() {
    for (let i = 0; i < this.VehicleArrivedMarkersOnMap.length; i++) {
      this.VehicleArrivedMarkersOnMap[i].setMap(null);
    }
    this.VehicleArrivedMarkersOnMap = [];
  }

  removeplotCallEmployeeMarkersOnMap() {
    for (let i = 0; i < this.callEmployeesMarkersOnMap.length; i++) {
      this.callEmployeesMarkersOnMap[i].setMap(null);
    }
    this.callEmployeesMarkersOnMap = [];
  }

  ngOnDestroy(): void {
    this.socketRef.unsubscribe(this.IMEI);
    clearInterval(this.trackingInterval);
  }

  tabs:any[] = ['Legacy','Modern'];
  setDefaultTab(){
    this.activeRoute.url.subscribe((url) => {
      this.defaultTab = url[0].path === 'trip-view' ? 'Modern' : 'Legacy';
    })
  }
  defaultTab = 'Modern'
  handleSelectedTab(event: any) {
    event === 'Legacy' ? this.openLegacy() : ''
  }
  openLegacy()  {
    setTimeout(() => {
      window.parent.location.href = this.commonService.createOldRoute();
    }, 200);
  }


}

